import { Phase, ScheduleEntryColourCode, SessionSequenceEntry } from '../../../entities';

export const transitionBeepAudioTipFileName = '0TRANSITION_BEEP';
export function homeTransistionSequenceForTrain(
    transitionDuration: number, zone: number, quarter: number): SessionSequenceEntry {
    return {
      durationInMilliseconds: transitionDuration,
      videoFile: '0TRANSITION_TO_TRAIN',
      exerciseVersion: '',
      displayName: '',
      displayBurnOrBuildIcon: false,
      progressColourCode: ScheduleEntryColourCode.Rest,
      progressText: '',
      showProcessedMetrics: false,
      showCalculatedMetrics: true,
      tips: [],
      audioTipStartDelay: 1000,
      audioTipFileName: transitionBeepAudioTipFileName,
      audioTips: [{
        fileName: transitionBeepAudioTipFileName, delay: 0,
      }],
      audioTipShouldCache: true,
      zone,
      quarter,
      phase: Phase.ChangeZone,
    };
  }

export function homeTransistionSequenceForRest(
    transitionDuration: number, zone: number, quarter: number): SessionSequenceEntry {
    return {
      durationInMilliseconds: transitionDuration,
      videoFile: '0TRANSITION_TO_RESTANDLEARN',
      exerciseVersion: '',
      displayName: '',
      displayBurnOrBuildIcon: false,
      progressColourCode: ScheduleEntryColourCode.Rest,
      progressText: '',
      showProcessedMetrics: false,
      showCalculatedMetrics: true,
      tips: [],
      audioTipStartDelay: 0,
      audioTipFileName: transitionBeepAudioTipFileName,
      audioTips: [{
        fileName: transitionBeepAudioTipFileName, delay: 0,
      }],
      audioTipShouldCache: true,
      zone,
      quarter,
      phase: Phase.ChangeZone,
    };
  }
